import { useMutation } from '@tanstack/react-query';

import { getXeroInvoiceDisconnect } from '../api';
import { xeroInvoiceMutationKeys } from '../data';

export const useXeroInvoiceDisconnect = () => {
  const mutation = useMutation({
    mutationKey: xeroInvoiceMutationKeys.disconnect,
    mutationFn: getXeroInvoiceDisconnect,
  });

  return mutation;
};
